// src/PencilIcon.tsx
import { jsx } from "react/jsx-runtime";
var PencilIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M4.14361 16.0634C3.93322 16.063 3.73266 15.9743 3.59086 15.8189C3.44644 15.6647 3.37468 15.4563 3.39361 15.2459L3.57736 13.2254L12.0659 4.73989L14.7186 7.39189L6.23236 15.8766L4.21186 16.0604C4.18861 16.0626 4.16536 16.0634 4.14361 16.0634ZM15.2481 6.86164L12.5961 4.20964L14.1869 2.61889C14.3275 2.47806 14.5184 2.39893 14.7175 2.39893C14.9165 2.39893 15.1074 2.47806 15.2481 2.61889L16.8389 4.20964C16.9797 4.35032 17.0588 4.54121 17.0588 4.74027C17.0588 4.93932 16.9797 5.13021 16.8389 5.27089L15.2489 6.86089L15.2481 6.86164Z" })
  }
);
var PencilIcon_default = PencilIcon;

export {
  PencilIcon_default
};
